// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/components/HistoryModal.css */

.history-modal .modal-dialog {
  max-width: 1200px;
}

.history-modal-header {
  background: #000;
  color: #fff;
  border-bottom: 1px solid #333;
  padding: 8px 15px;
}

.history-modal-header .modal-title {
  font-family: 'MS Gothic', 'MS UI Gothic', monospace;
  font-size: 16px;
  font-weight: normal;
  color: #ffff00;
}

.history-modal-body {
  background: #000;
  color: #fff;
  padding: 10px;
  font-family: 'MS Gothic', 'MS UI Gothic', monospace;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #888;
}

.history-container {
  width: 100%;
}

.history-legend {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 20px;
  padding: 15px;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  border: none;
  border-radius: 10px;
  font-size: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ccc;
}

/* 设备名称醒目样式 */
.device-name {
  font-size: 16px;
  font-weight: bold;
  color: #ffff00;
  text-shadow: 0 0 3px #ffff00;
  font-family: 'MS Gothic', 'MS UI Gothic', monospace;
}

.legend-color {
  width: 16px;
  height: 16px;
  border: 1px solid #555;
}

.legend-color.active {
  background: linear-gradient(135deg, #00ff88 0%, #00cc66 100%);
  box-shadow: 0 0 4px rgba(0, 255, 136, 0.4);
}

.legend-color.active.red {
  background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
  box-shadow: 0 0 4px rgba(255, 68, 68, 0.6);
  animation: redGridBlink 1.5s infinite ease-in-out;
}

.legend-color.inactive {
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
  border: 1px solid #333;
}

.history-grid-container {
  background: linear-gradient(145deg, #0a0a0a 0%, #1a1a1a 100%);
  border: none;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  overflow-x: auto;
  overflow-y: hidden;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.4);
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.scroll-hint {
  text-align: center;
  margin-bottom: 10px;
  color: #888;
  font-size: 12px;
  opacity: 0.8;
  animation: fadeInOut 3s ease-in-out infinite;
}

@keyframes fadeInOut {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

@keyframes redGridBlink {
  0% { 
    background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
    box-shadow: 0 0 8px rgba(255, 68, 68, 0.6);
    transform: scale(1);
  }
  50% { 
    background: linear-gradient(135deg, #ff6666 0%, #ff4444 100%);
    box-shadow: 0 0 15px rgba(255, 68, 68, 1);
    transform: scale(1.05);
  }
  100% { 
    background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
    box-shadow: 0 0 8px rgba(255, 68, 68, 0.6);
    transform: scale(1);
  }
}

.columns-container {
  display: flex;
  gap: 15px;
  min-width: max-content;
  padding: 10px 0;
  width: max-content;
}

.history-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
  padding: 8px;
}

.round-header {
  margin-bottom: 8px;
  text-align: center;
}

.round-number {
  font-size: 10px;
  color: #999;
  margin-bottom: 4px;
  font-weight: 500;
}

.total-turns {
  font-size: 13px;
  color: #00ff88;
  font-weight: bold;
  text-shadow: 0 0 4px rgba(0, 255, 136, 0.5);
}

.grids-column {
  display: flex;
  flex-direction: column-reverse; /* 从底部开始排列 */
  gap: 1px;
  height: 180px; /* 稍微降低高度 */
  justify-content: flex-start; /* 格子从底部开始对齐 */
  align-items: center;
  margin: 10px 0;
}

.history-grid {
  width: 50px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  border: none;
  border-radius: 3px;
  font-family: 'MS Gothic', monospace;
  transition: all 0.3s ease;
  margin: 1px 0;
}

.history-grid.active {
  background: linear-gradient(135deg, #00ff88 0%, #00cc66 100%);
  color: #000;
  font-weight: bold;
  box-shadow: 0 0 8px rgba(0, 255, 136, 0.4);
}

.history-grid.active.red {
  background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
  color: #fff;
  font-weight: bold;
  box-shadow: 0 0 8px rgba(255, 68, 68, 0.6);
  animation: redGridBlink 1.5s infinite ease-in-out;
}

.history-grid.active:hover {
  box-shadow: 0 0 12px rgba(0, 255, 136, 0.6);
  transform: scale(1.05);
}

.history-grid.active.red:hover {
  box-shadow: 0 0 18px rgba(255, 68, 68, 1);
  transform: scale(1.1);
  animation-duration: 1s; /* 悬停时加快闪烁 */
}

.history-grid.inactive {
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
  color: #666;
  border: 1px solid #333;
}

.grid-turns {
  font-size: 8px;
}

.consecutive-wins {
  margin-top: 8px;
  font-size: 14px;
  color: #ff4d6d;
  font-weight: bold;
  text-align: center;
  min-height: 20px;
  text-shadow: 0 0 6px rgba(255, 77, 109, 0.6);
}

.history-stats {
  display: flex;
  justify-content: space-around;
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 20px 0;
  font-size: 11px;
  margin-top: 20px;
  flex-wrap: nowrap;
  align-items: center;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 0;
  background: transparent;
  border-radius: 0;
  transition: all 0.3s ease;
  flex: 1 1;
  min-width: 0;
}

.stat-item::before {
  display: none;
}

.stat-item:hover {
  background: transparent;
  transform: none;
  box-shadow: none;
}

.stat-item span:first-child {
  color: #bbb;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-item span:last-child {
  color: #00ff88;
  font-weight: bold;
  font-size: 18px;
  text-shadow: 0 0 6px rgba(0, 255, 136, 0.4);
  font-family: 'Courier New', monospace;
}

/* 错误消息样式 */
.error-message {
  text-align: center;
  padding: 10px;
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid #ffc107;
  border-radius: 4px;
  color: #ffc107;
  font-size: 12px;
}

/* 轮次详细信息样式 */
.round-info {
  font-size: 10px;
  color: #888;
  text-align: center;
  margin-top: 2px;
  cursor: help;
}

.round-info:hover {
  color: #fff;
}

/* 视图模式切换控件样式 */
.view-controls {
  margin-bottom: 20px;
}

.view-controls .device-name {
  color: #ffff00;
  font-weight: bold;
  font-size: 14px;
}

.view-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.view-buttons .btn-group .btn {
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 4px;
  font-family: 'MS Gothic', 'MS UI Gothic', monospace;
}

.view-buttons .btn-outline-primary {
  color: #fff;
  border-color: #007bff;
  background-color: transparent;
}

.view-buttons .btn-outline-primary:hover {
  background-color: #007bff;
  border-color: #007bff;
}

.view-buttons .btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.view-buttons .btn-outline-success {
  color: #fff;
  border-color: #28a745;
  background-color: transparent;
}

.view-buttons .btn-outline-success:hover {
  background-color: #28a745;
  border-color: #28a745;
}

.view-buttons .btn-success {
  background-color: #28a745;
  border-color: #28a745;
}

/* 图表容器样式 */
.chart-container {
  background: #1a1a1a;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

/* 移动端红色格子闪烁优化 */
@media (max-width: 768px) {
  .history-grid.active.red {
    animation: redGridBlinkMobile 1.8s infinite ease-in-out;
  }
  
  .legend-color.active.red {
    animation: redGridBlinkMobile 1.8s infinite ease-in-out;
  }
}

@keyframes redGridBlinkMobile {
  0% { 
    background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
    box-shadow: 0 0 6px rgba(255, 68, 68, 0.6);
    transform: scale(1);
  }
  50% { 
    background: linear-gradient(135deg, #ff6666 0%, #ff4444 100%);
    box-shadow: 0 0 10px rgba(255, 68, 68, 0.9);
    transform: scale(1.03);
  }
  100% { 
    background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
    box-shadow: 0 0 6px rgba(255, 68, 68, 0.6);
    transform: scale(1);
  }
}
@media (max-width: 768px) {
  .view-controls .d-flex {
    flex-direction: column;
    gap: 15px;
    align-items: stretch !important;
  }
  
  .view-controls .device-name {
    text-align: center;
    font-size: 12px;
  }
  
  .view-buttons {
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .view-buttons .btn-group {
    margin-bottom: 10px;
  }
  
  .view-buttons .btn-group .btn {
    font-size: 11px;
    padding: 5px 10px;
  }
  
  .chart-container {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .view-buttons {
    flex-direction: column;
    gap: 8px;
  }
  
  .view-buttons .btn-group {
    display: flex;
    width: 100%;
    margin-bottom: 8px;
  }
  
  .view-buttons .btn-group .btn {
    flex: 1 1;
    font-size: 10px;
    padding: 4px 8px;
  }
  
  .chart-container {
    padding: 10px;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .history-modal .modal-dialog {
    max-width: 90vw;
    margin: 20px auto;
    max-height: 85vh;
  }
  
  .history-modal .modal-content {
    max-height: 85vh;
    display: flex;
    flex-direction: column;
  }
  
  .history-modal-header {
    padding: 8px 12px;
    flex-shrink: 0;
  }
  
  .history-modal-header .modal-title {
    font-size: 14px;
  }
  
  .history-modal-body {
    padding: 10px;
    overflow-y: auto;
    flex: 1 1;
  }
  
  .history-modal-footer {
    padding: 10px 15px;
    flex-shrink: 0;
    background: #000;
    border-top: 1px solid #333;
  }
  
  .close-button.mobile {
    width: 100%;
    padding: 12px;
    font-size: 16px;
    font-weight: bold;
    background: #dc3545;
    border: none;
    border-radius: 6px;
    color: white;
    transition: background 0.3s ease;
  }
  
  .close-button.mobile:hover {
    background: #c82333;
  }
  
  .history-legend {
    padding: 8px;
    margin-bottom: 10px;
    border-radius: 6px;
  }
  
  .device-name {
    font-size: 14px;
  }
  
  .history-grid-container {
    padding: 8px;
    margin-bottom: 10px;
    border-radius: 6px;
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    overflow-y: hidden;
  }
  
  .scroll-hint {
    font-size: 10px;
    margin-bottom: 8px;
  }
  
  .columns-container {
    gap: 8px;
    padding: 5px 0;
    touch-action: pan-x;
  }
  
  .history-column {
    min-width: 45px;
    padding: 4px;
  }
  
  .round-number {
    font-size: 9px;
  }
  
  .total-turns {
    font-size: 11px;
  }
  
  .grids-column {
    height: 120px;
    margin: 6px 0;
    gap: 1px;
  }
  
  .history-grid {
    width: 40px;
    height: 12px;
    font-size: 8px;
    border-radius: 2px;
  }
  
  .consecutive-wins {
    font-size: 11px;
    margin-top: 4px;
  }
  
  .history-stats {
    padding: 10px 0;
    margin-top: 10px;
    flex-wrap: nowrap;
    gap: 8px;
    overflow-x: auto;
  }
  
  .stat-item {
    min-width: 65px;
    flex: 1 1;
    gap: 4px;
  }
  
  .stat-item span:first-child {
    font-size: 9px;
  }
  
  .stat-item span:last-child {
    font-size: 14px;
  }
}

/* 超小屏幕设备优化 (手机竖屏) */
@media (max-width: 480px) {
  .history-modal .modal-dialog {
    max-width: 95vw;
    margin: 15px auto;
    max-height: 90vh;
  }
  
  .history-modal-header {
    padding: 6px 10px;
  }
  
  .history-modal-header .modal-title {
    font-size: 12px;
  }
  
  .history-modal-body {
    padding: 8px;
  }
  
  .history-legend {
    padding: 6px;
    margin-bottom: 8px;
  }
  
  .device-name {
    font-size: 12px;
  }
  
  .history-grid-container {
    padding: 6px;
    margin-bottom: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
  
  .scroll-hint {
    font-size: 9px;
    margin-bottom: 6px;
  }
  
  .columns-container {
    gap: 6px;
  }
  
  .history-column {
    min-width: 38px;
    padding: 2px;
  }
  
  .round-number {
    font-size: 8px;
  }
  
  .total-turns {
    font-size: 10px;
  }
  
  .grids-column {
    height: 100px;
    margin: 4px 0;
  }
  
  .history-grid {
    width: 34px;
    height: 10px;
    font-size: 7px;
  }
  
  .consecutive-wins {
    font-size: 10px;
    margin-top: 3px;
  }
  
  .history-stats {
    padding: 8px 0;
    margin-top: 8px;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 4px;
    overflow-x: auto;
  }
  
  .stat-item {
    min-width: 50px;
    flex: 1 1;
    gap: 3px;
  }
  
  .stat-item span:first-child {
    font-size: 8px;
  }
  
  .stat-item span:last-child {
    font-size: 12px;
  }
}

/* 移动设备字体优化 */
@media (max-width: 768px) {
  .history-modal_body,
  .device-name,
  .total-turns,
  .consecutive-wins,
  .stat-item span {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif, 'MS Gothic';
  }
}

/* 液体玻璃效果动画 */
@keyframes liquidFlow {
  0% {
    background-position: 0% 0%;
  }
  25% {
    background-position: 100% 50%;
  }
  50% {
    background-position: 50% 100%;
  }
  75% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 0% 0%;
  }
}

@keyframes glassShimmer {
  0% {
    transform: translateX(-100%) skewX(-15deg);
  }
  50% {
    transform: translateX(0%) skewX(-15deg);
  }
  100% {
    transform: translateX(100%) skewX(-15deg);
  }
}

@keyframes liquidBubble {
  0% {
    transform: translateY(0px) scale(1);
    opacity: 0.7;
  }
  50% {
    transform: translateY(-10px) scale(1.1);
    opacity: 1;
  }
  100% {
    transform: translateY(0px) scale(1);
    opacity: 0.7;
  }
}

/* 液体玻璃控制台样式 */
.liquid-glass-console {
  background: 
    linear-gradient(
      135deg,
      rgba(30, 41, 59, 0.8) 0%,
      rgba(15, 23, 42, 0.9) 25%,
      rgba(59, 130, 246, 0.15) 50%,
      rgba(15, 23, 42, 0.9) 75%,
      rgba(30, 41, 59, 0.8) 100%
    );
  background-size: 300% 300%;
  animation: liquidFlow 8s ease-in-out infinite;
  backdrop-filter: blur(15px) saturate(200%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;
}

.liquid-glass-console::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  animation: glassShimmer 4s ease-in-out infinite;
  z-index: 1;
  pointer-events: none;
}

.liquid-glass-console::after {
  content: '';
  position: absolute;
  top: 20%;
  right: 20%;
  width: 8px;
  height: 8px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  animation: liquidBubble 3s ease-in-out infinite;
  z-index: 1;
  pointer-events: none;
}

/* 控制台按钮的额外液体效果 */
.liquid-glass-btn {
  position: relative;
  background: 
    linear-gradient(
      135deg,
      rgba(59, 130, 246, 0.2) 0%,
      rgba(30, 41, 59, 0.8) 50%,
      rgba(59, 130, 246, 0.2) 100%
    );
  background-size: 200% 200%;
  animation: liquidFlow 6s ease-in-out infinite;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.liquid-glass-btn:hover {
  background-size: 150% 150%;
  animation-duration: 3s;
  transform: translateY(-3px) scale(1.02);
  box-shadow: 
    0 10px 25px rgba(0, 0, 0, 0.4), 
    0 0 20px rgba(59, 130, 246, 0.3),
    inset 0 0 20px rgba(255, 255, 255, 0.1);
}

.liquid-glass-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.15),
    transparent
  );
  animation: glassShimmer 5s ease-in-out infinite;
  z-index: 2;
  pointer-events: none;
  border-radius: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/components/HistoryModal.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA,aAAa;AACb;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;EACE,6DAA6D;EAC7D,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE;IACE,6DAA6D;IAC7D,0CAA0C;IAC1C,mBAAmB;EACrB;EACA;IACE,6DAA6D;IAC7D,yCAAyC;IACzC,sBAAsB;EACxB;EACA;IACE,6DAA6D;IAC7D,0CAA0C;IAC1C,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,YAAY;EAC5C,QAAQ;EACR,aAAa,EAAE,WAAW;EAC1B,2BAA2B,EAAE,cAAc;EAC3C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,iBAAiB;EACjB,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,sBAAsB,EAAE,YAAY;AACtC;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,gBAAgB;AAChB;EACE;IACE,uDAAuD;EACzD;;EAEA;IACE,uDAAuD;EACzD;AACF;;AAEA;EACE;IACE,6DAA6D;IAC7D,0CAA0C;IAC1C,mBAAmB;EACrB;EACA;IACE,6DAA6D;IAC7D,2CAA2C;IAC3C,sBAAsB;EACxB;EACA;IACE,6DAA6D;IAC7D,0CAA0C;IAC1C,mBAAmB;EACrB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,UAAU;AACV;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,SAAO;IACP,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,SAAO;IACP,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,aAAa;AACb;EACE;;;;;IAKE,sHAAsH;EACxH;AACF;;AAEA,aAAa;AACb;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,uCAAuC;EACzC;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,mCAAmC;IACnC,YAAY;EACd;EACA;IACE,uCAAuC;IACvC,UAAU;EACZ;EACA;IACE,mCAAmC;IACnC,YAAY;EACd;AACF;;AAEA,cAAc;AACd;EACE;;;;;;;;KAQG;EACH,0BAA0B;EAC1B,6CAA6C;EAC7C,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,+CAA+C;EAC/C,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,+CAA+C;EAC/C,UAAU;EACV,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB;;;;;;KAMG;EACH,0BAA0B;EAC1B,6CAA6C;EAC7C,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,uCAAuC;EACvC;;;2CAGyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,+CAA+C;EAC/C,UAAU;EACV,oBAAoB;EACpB,sBAAsB;AACxB","sourcesContent":["/* frontend/src/components/HistoryModal.css */\n\n.history-modal .modal-dialog {\n  max-width: 1200px;\n}\n\n.history-modal-header {\n  background: #000;\n  color: #fff;\n  border-bottom: 1px solid #333;\n  padding: 8px 15px;\n}\n\n.history-modal-header .modal-title {\n  font-family: 'MS Gothic', 'MS UI Gothic', monospace;\n  font-size: 16px;\n  font-weight: normal;\n  color: #ffff00;\n}\n\n.history-modal-body {\n  background: #000;\n  color: #fff;\n  padding: 10px;\n  font-family: 'MS Gothic', 'MS UI Gothic', monospace;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #888;\n}\n\n.history-container {\n  width: 100%;\n}\n\n.history-legend {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n  margin-bottom: 20px;\n  padding: 15px;\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n  border: none;\n  border-radius: 10px;\n  font-size: 12px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #ccc;\n}\n\n/* 设备名称醒目样式 */\n.device-name {\n  font-size: 16px;\n  font-weight: bold;\n  color: #ffff00;\n  text-shadow: 0 0 3px #ffff00;\n  font-family: 'MS Gothic', 'MS UI Gothic', monospace;\n}\n\n.legend-color {\n  width: 16px;\n  height: 16px;\n  border: 1px solid #555;\n}\n\n.legend-color.active {\n  background: linear-gradient(135deg, #00ff88 0%, #00cc66 100%);\n  box-shadow: 0 0 4px rgba(0, 255, 136, 0.4);\n}\n\n.legend-color.active.red {\n  background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);\n  box-shadow: 0 0 4px rgba(255, 68, 68, 0.6);\n  animation: redGridBlink 1.5s infinite ease-in-out;\n}\n\n.legend-color.inactive {\n  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);\n  border: 1px solid #333;\n}\n\n.history-grid-container {\n  background: linear-gradient(145deg, #0a0a0a 0%, #1a1a1a 100%);\n  border: none;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 20px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.4);\n  -webkit-overflow-scrolling: touch;\n  scroll-behavior: smooth;\n}\n\n.scroll-hint {\n  text-align: center;\n  margin-bottom: 10px;\n  color: #888;\n  font-size: 12px;\n  opacity: 0.8;\n  animation: fadeInOut 3s ease-in-out infinite;\n}\n\n@keyframes fadeInOut {\n  0%, 100% { opacity: 0.5; }\n  50% { opacity: 1; }\n}\n\n@keyframes redGridBlink {\n  0% { \n    background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);\n    box-shadow: 0 0 8px rgba(255, 68, 68, 0.6);\n    transform: scale(1);\n  }\n  50% { \n    background: linear-gradient(135deg, #ff6666 0%, #ff4444 100%);\n    box-shadow: 0 0 15px rgba(255, 68, 68, 1);\n    transform: scale(1.05);\n  }\n  100% { \n    background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);\n    box-shadow: 0 0 8px rgba(255, 68, 68, 0.6);\n    transform: scale(1);\n  }\n}\n\n.columns-container {\n  display: flex;\n  gap: 15px;\n  min-width: max-content;\n  padding: 10px 0;\n  width: max-content;\n}\n\n.history-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 60px;\n  padding: 8px;\n}\n\n.round-header {\n  margin-bottom: 8px;\n  text-align: center;\n}\n\n.round-number {\n  font-size: 10px;\n  color: #999;\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.total-turns {\n  font-size: 13px;\n  color: #00ff88;\n  font-weight: bold;\n  text-shadow: 0 0 4px rgba(0, 255, 136, 0.5);\n}\n\n.grids-column {\n  display: flex;\n  flex-direction: column-reverse; /* 从底部开始排列 */\n  gap: 1px;\n  height: 180px; /* 稍微降低高度 */\n  justify-content: flex-start; /* 格子从底部开始对齐 */\n  align-items: center;\n  margin: 10px 0;\n}\n\n.history-grid {\n  width: 50px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9px;\n  border: none;\n  border-radius: 3px;\n  font-family: 'MS Gothic', monospace;\n  transition: all 0.3s ease;\n  margin: 1px 0;\n}\n\n.history-grid.active {\n  background: linear-gradient(135deg, #00ff88 0%, #00cc66 100%);\n  color: #000;\n  font-weight: bold;\n  box-shadow: 0 0 8px rgba(0, 255, 136, 0.4);\n}\n\n.history-grid.active.red {\n  background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);\n  color: #fff;\n  font-weight: bold;\n  box-shadow: 0 0 8px rgba(255, 68, 68, 0.6);\n  animation: redGridBlink 1.5s infinite ease-in-out;\n}\n\n.history-grid.active:hover {\n  box-shadow: 0 0 12px rgba(0, 255, 136, 0.6);\n  transform: scale(1.05);\n}\n\n.history-grid.active.red:hover {\n  box-shadow: 0 0 18px rgba(255, 68, 68, 1);\n  transform: scale(1.1);\n  animation-duration: 1s; /* 悬停时加快闪烁 */\n}\n\n.history-grid.inactive {\n  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);\n  color: #666;\n  border: 1px solid #333;\n}\n\n.grid-turns {\n  font-size: 8px;\n}\n\n.consecutive-wins {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #ff4d6d;\n  font-weight: bold;\n  text-align: center;\n  min-height: 20px;\n  text-shadow: 0 0 6px rgba(255, 77, 109, 0.6);\n}\n\n.history-stats {\n  display: flex;\n  justify-content: space-around;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 20px 0;\n  font-size: 11px;\n  margin-top: 20px;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 0;\n  background: transparent;\n  border-radius: 0;\n  transition: all 0.3s ease;\n  flex: 1;\n  min-width: 0;\n}\n\n.stat-item::before {\n  display: none;\n}\n\n.stat-item:hover {\n  background: transparent;\n  transform: none;\n  box-shadow: none;\n}\n\n.stat-item span:first-child {\n  color: #bbb;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-item span:last-child {\n  color: #00ff88;\n  font-weight: bold;\n  font-size: 18px;\n  text-shadow: 0 0 6px rgba(0, 255, 136, 0.4);\n  font-family: 'Courier New', monospace;\n}\n\n/* 错误消息样式 */\n.error-message {\n  text-align: center;\n  padding: 10px;\n  background: rgba(255, 193, 7, 0.1);\n  border: 1px solid #ffc107;\n  border-radius: 4px;\n  color: #ffc107;\n  font-size: 12px;\n}\n\n/* 轮次详细信息样式 */\n.round-info {\n  font-size: 10px;\n  color: #888;\n  text-align: center;\n  margin-top: 2px;\n  cursor: help;\n}\n\n.round-info:hover {\n  color: #fff;\n}\n\n/* 视图模式切换控件样式 */\n.view-controls {\n  margin-bottom: 20px;\n}\n\n.view-controls .device-name {\n  color: #ffff00;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.view-buttons {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.view-buttons .btn-group .btn {\n  font-size: 12px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-family: 'MS Gothic', 'MS UI Gothic', monospace;\n}\n\n.view-buttons .btn-outline-primary {\n  color: #fff;\n  border-color: #007bff;\n  background-color: transparent;\n}\n\n.view-buttons .btn-outline-primary:hover {\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.view-buttons .btn-primary {\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.view-buttons .btn-outline-success {\n  color: #fff;\n  border-color: #28a745;\n  background-color: transparent;\n}\n\n.view-buttons .btn-outline-success:hover {\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n.view-buttons .btn-success {\n  background-color: #28a745;\n  border-color: #28a745;\n}\n\n/* 图表容器样式 */\n.chart-container {\n  background: #1a1a1a;\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n}\n\n/* 移动端红色格子闪烁优化 */\n@media (max-width: 768px) {\n  .history-grid.active.red {\n    animation: redGridBlinkMobile 1.8s infinite ease-in-out;\n  }\n  \n  .legend-color.active.red {\n    animation: redGridBlinkMobile 1.8s infinite ease-in-out;\n  }\n}\n\n@keyframes redGridBlinkMobile {\n  0% { \n    background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);\n    box-shadow: 0 0 6px rgba(255, 68, 68, 0.6);\n    transform: scale(1);\n  }\n  50% { \n    background: linear-gradient(135deg, #ff6666 0%, #ff4444 100%);\n    box-shadow: 0 0 10px rgba(255, 68, 68, 0.9);\n    transform: scale(1.03);\n  }\n  100% { \n    background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);\n    box-shadow: 0 0 6px rgba(255, 68, 68, 0.6);\n    transform: scale(1);\n  }\n}\n@media (max-width: 768px) {\n  .view-controls .d-flex {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch !important;\n  }\n  \n  .view-controls .device-name {\n    text-align: center;\n    font-size: 12px;\n  }\n  \n  .view-buttons {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n  \n  .view-buttons .btn-group {\n    margin-bottom: 10px;\n  }\n  \n  .view-buttons .btn-group .btn {\n    font-size: 11px;\n    padding: 5px 10px;\n  }\n  \n  .chart-container {\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .view-buttons {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .view-buttons .btn-group {\n    display: flex;\n    width: 100%;\n    margin-bottom: 8px;\n  }\n  \n  .view-buttons .btn-group .btn {\n    flex: 1;\n    font-size: 10px;\n    padding: 4px 8px;\n  }\n  \n  .chart-container {\n    padding: 10px;\n  }\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .history-modal .modal-dialog {\n    max-width: 90vw;\n    margin: 20px auto;\n    max-height: 85vh;\n  }\n  \n  .history-modal .modal-content {\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .history-modal-header {\n    padding: 8px 12px;\n    flex-shrink: 0;\n  }\n  \n  .history-modal-header .modal-title {\n    font-size: 14px;\n  }\n  \n  .history-modal-body {\n    padding: 10px;\n    overflow-y: auto;\n    flex: 1;\n  }\n  \n  .history-modal-footer {\n    padding: 10px 15px;\n    flex-shrink: 0;\n    background: #000;\n    border-top: 1px solid #333;\n  }\n  \n  .close-button.mobile {\n    width: 100%;\n    padding: 12px;\n    font-size: 16px;\n    font-weight: bold;\n    background: #dc3545;\n    border: none;\n    border-radius: 6px;\n    color: white;\n    transition: background 0.3s ease;\n  }\n  \n  .close-button.mobile:hover {\n    background: #c82333;\n  }\n  \n  .history-legend {\n    padding: 8px;\n    margin-bottom: 10px;\n    border-radius: 6px;\n  }\n  \n  .device-name {\n    font-size: 14px;\n  }\n  \n  .history-grid-container {\n    padding: 8px;\n    margin-bottom: 10px;\n    border-radius: 6px;\n    -webkit-overflow-scrolling: touch;\n    overflow-x: auto;\n    overflow-y: hidden;\n  }\n  \n  .scroll-hint {\n    font-size: 10px;\n    margin-bottom: 8px;\n  }\n  \n  .columns-container {\n    gap: 8px;\n    padding: 5px 0;\n    touch-action: pan-x;\n  }\n  \n  .history-column {\n    min-width: 45px;\n    padding: 4px;\n  }\n  \n  .round-number {\n    font-size: 9px;\n  }\n  \n  .total-turns {\n    font-size: 11px;\n  }\n  \n  .grids-column {\n    height: 120px;\n    margin: 6px 0;\n    gap: 1px;\n  }\n  \n  .history-grid {\n    width: 40px;\n    height: 12px;\n    font-size: 8px;\n    border-radius: 2px;\n  }\n  \n  .consecutive-wins {\n    font-size: 11px;\n    margin-top: 4px;\n  }\n  \n  .history-stats {\n    padding: 10px 0;\n    margin-top: 10px;\n    flex-wrap: nowrap;\n    gap: 8px;\n    overflow-x: auto;\n  }\n  \n  .stat-item {\n    min-width: 65px;\n    flex: 1;\n    gap: 4px;\n  }\n  \n  .stat-item span:first-child {\n    font-size: 9px;\n  }\n  \n  .stat-item span:last-child {\n    font-size: 14px;\n  }\n}\n\n/* 超小屏幕设备优化 (手机竖屏) */\n@media (max-width: 480px) {\n  .history-modal .modal-dialog {\n    max-width: 95vw;\n    margin: 15px auto;\n    max-height: 90vh;\n  }\n  \n  .history-modal-header {\n    padding: 6px 10px;\n  }\n  \n  .history-modal-header .modal-title {\n    font-size: 12px;\n  }\n  \n  .history-modal-body {\n    padding: 8px;\n  }\n  \n  .history-legend {\n    padding: 6px;\n    margin-bottom: 8px;\n  }\n  \n  .device-name {\n    font-size: 12px;\n  }\n  \n  .history-grid-container {\n    padding: 6px;\n    margin-bottom: 8px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n  }\n  \n  .scroll-hint {\n    font-size: 9px;\n    margin-bottom: 6px;\n  }\n  \n  .columns-container {\n    gap: 6px;\n  }\n  \n  .history-column {\n    min-width: 38px;\n    padding: 2px;\n  }\n  \n  .round-number {\n    font-size: 8px;\n  }\n  \n  .total-turns {\n    font-size: 10px;\n  }\n  \n  .grids-column {\n    height: 100px;\n    margin: 4px 0;\n  }\n  \n  .history-grid {\n    width: 34px;\n    height: 10px;\n    font-size: 7px;\n  }\n  \n  .consecutive-wins {\n    font-size: 10px;\n    margin-top: 3px;\n  }\n  \n  .history-stats {\n    padding: 8px 0;\n    margin-top: 8px;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    gap: 4px;\n    overflow-x: auto;\n  }\n  \n  .stat-item {\n    min-width: 50px;\n    flex: 1;\n    gap: 3px;\n  }\n  \n  .stat-item span:first-child {\n    font-size: 8px;\n  }\n  \n  .stat-item span:last-child {\n    font-size: 12px;\n  }\n}\n\n/* 移动设备字体优化 */\n@media (max-width: 768px) {\n  .history-modal_body,\n  .device-name,\n  .total-turns,\n  .consecutive-wins,\n  .stat-item span {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif, 'MS Gothic';\n  }\n}\n\n/* 液体玻璃效果动画 */\n@keyframes liquidFlow {\n  0% {\n    background-position: 0% 0%;\n  }\n  25% {\n    background-position: 100% 50%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  75% {\n    background-position: 0% 50%;\n  }\n  100% {\n    background-position: 0% 0%;\n  }\n}\n\n@keyframes glassShimmer {\n  0% {\n    transform: translateX(-100%) skewX(-15deg);\n  }\n  50% {\n    transform: translateX(0%) skewX(-15deg);\n  }\n  100% {\n    transform: translateX(100%) skewX(-15deg);\n  }\n}\n\n@keyframes liquidBubble {\n  0% {\n    transform: translateY(0px) scale(1);\n    opacity: 0.7;\n  }\n  50% {\n    transform: translateY(-10px) scale(1.1);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(0px) scale(1);\n    opacity: 0.7;\n  }\n}\n\n/* 液体玻璃控制台样式 */\n.liquid-glass-console {\n  background: \n    linear-gradient(\n      135deg,\n      rgba(30, 41, 59, 0.8) 0%,\n      rgba(15, 23, 42, 0.9) 25%,\n      rgba(59, 130, 246, 0.15) 50%,\n      rgba(15, 23, 42, 0.9) 75%,\n      rgba(30, 41, 59, 0.8) 100%\n    );\n  background-size: 300% 300%;\n  animation: liquidFlow 8s ease-in-out infinite;\n  backdrop-filter: blur(15px) saturate(200%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.liquid-glass-console::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.2),\n    transparent\n  );\n  animation: glassShimmer 4s ease-in-out infinite;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.liquid-glass-console::after {\n  content: '';\n  position: absolute;\n  top: 20%;\n  right: 20%;\n  width: 8px;\n  height: 8px;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  animation: liquidBubble 3s ease-in-out infinite;\n  z-index: 1;\n  pointer-events: none;\n}\n\n/* 控制台按钮的额外液体效果 */\n.liquid-glass-btn {\n  position: relative;\n  background: \n    linear-gradient(\n      135deg,\n      rgba(59, 130, 246, 0.2) 0%,\n      rgba(30, 41, 59, 0.8) 50%,\n      rgba(59, 130, 246, 0.2) 100%\n    );\n  background-size: 200% 200%;\n  animation: liquidFlow 6s ease-in-out infinite;\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n}\n\n.liquid-glass-btn:hover {\n  background-size: 150% 150%;\n  animation-duration: 3s;\n  transform: translateY(-3px) scale(1.02);\n  box-shadow: \n    0 10px 25px rgba(0, 0, 0, 0.4), \n    0 0 20px rgba(59, 130, 246, 0.3),\n    inset 0 0 20px rgba(255, 255, 255, 0.1);\n}\n\n.liquid-glass-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.15),\n    transparent\n  );\n  animation: glassShimmer 5s ease-in-out infinite;\n  z-index: 2;\n  pointer-events: none;\n  border-radius: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
